
import  { useState } from 'react';
import leaf from "../../../../src/assets/images/leaf.png"
import broken_heart from "../../../../src/assets/images/broken-heart.png"
import gear_icon from "../../../../src/assets/images/gear.png"


function wrapNameWithFontSize(firstName, lastName, maxChars, baseFontSize, minFontSize) {
  const lines = [];
  let decidedFontSize = baseFontSize; // Store font size decided by firstName

  // Helper function to process each name
  function processName(name, isFirstName = false) {
    if (typeof name !== 'string' || name.length === 0) {
      return;
    }

    if (isFirstName) {
      if (name.length <= maxChars) {
        decidedFontSize = baseFontSize;
        lines.push({ text: name, fontSize: decidedFontSize });
      } else {
        let adjustedFontSize = Math.floor((maxChars / name.length) * baseFontSize);
        if (adjustedFontSize >= minFontSize) {
          decidedFontSize = adjustedFontSize;
          lines.push({ text: name, fontSize: decidedFontSize });
        } else {
          decidedFontSize = minFontSize;
          const charsPerLine = 20;
          for (let i = 0; i < name.length; i += charsPerLine) {
            lines.push({ text: name.substring(i, i + charsPerLine), fontSize: decidedFontSize });
          }
        }
      }
    } else {
      // Always use decidedFontSize
      if (decidedFontSize > minFontSize || name.length <= maxChars) {
        lines.push({ text: name, fontSize: decidedFontSize });
      } else {
        const charsPerLine = 20;
        for (let i = 0; i < name.length; i += charsPerLine) {
          lines.push({ text: name.substring(i, i + charsPerLine), fontSize: decidedFontSize });
        }
      }
    }
  }

  processName(firstName, true);
  processName(lastName);

  return lines;
}


export function CardBody({ d, card_dim, card_display,color,font_family,font_size,font_color,module }) {
  // console.log(d.data)
  // const [day, month, year] = card_display[1](d.data).split('/');
  // console.log(day)
  // console.log(month)
  // console.log(year)
  // const birthDate = new Date(`${year}-${month}-${day}`);
  // const diffMilliseconds = Date.now() - birthDate.getTime();
  // const ageDate = new Date(diffMilliseconds);
  // let currentAge=Math.abs(ageDate.getUTCFullYear() - 1970);
  // currentAge=isNaN(currentAge) ? '' : currentAge+" Years";
  const maxChars = 14;
  const baseFontSize = 16;
  const minFontSize = 10;
  return {
    template: (`
<g class="card-body"  >
  <rect 
    width="${card_dim.w}" 
    height="${card_dim.h}" 
    class="card-body-rect" 
    rx="30" 
    ry="30" 
    style="fill: ${color};"
  />
  <g transform="translate(${card_dim.text_x}, ${card_dim.text_y})">
    <text class="member_name" clip-path="url(#card_text_clip)">
     ${
   wrapNameWithFontSize(d.data.data.first_name, d.data.data.last_name, maxChars, baseFontSize, minFontSize)
  .map((line, i) => `
    <tspan x="0" dy="${font_size*1.1}" class="title" 
      font-family="${font_family}" 
      font-size="${font_size}" 
      fill="${font_color}">${line.text}</tspan>
  `).join('')}
      <tspan x="${0}" dy="${14}" class="dob" font-size="10">${card_display[1](d.data)}</tspan>
    </text>
  </g>
</g>


  `)
  }
}

 

export function CardBodyAddNew({ d, card_dim, card_add, label }) {
  return {
    template: (`
    <g class="card-body ${card_add ? 'card_add' : 'card-unknown'}">
      <rect class="card-body-rect" width="${card_dim.w}" height="${card_dim.h}" fill="rgb(59, 85, 96)" rx="30" ry="30" />
      <text transform="translate(${card_dim.w / 2}, ${card_dim.h / 2})" text-anchor="middle" fill="#fff">
        <tspan font-size="18" dy="${8}">${label}</tspan>
      </text>
    </g>
  `)
  }
}

// export function CardBodyOutline({ d, card_dim, is_new }) {
//   return {
//     template: (`
//     <rect fill="none" width="${card_dim.w}" height="${card_dim.h}" rx="4" ry="4" class="card-outline ${(d.data.main && !is_new) ? 'card-main-outline' : ''} ${is_new ? 'card-new-outline' : ''}" />
//   `)
//   }
// }
export function CardBodyOutline({ d, card_dim, is_new }) {
  return {
    template: (`
    <rect 
      fill="none" 
      width="${card_dim.w}" 
      height="${card_dim.h}" 
      rx="4" 
      ry="4" 
      class="card-outline ${(d.data.main && !is_new) ? 'card-main-outline' : ''} ${is_new ? 'card-new-outline' : ''}" 
    />
    `)
  };
}

export function PencilIcon({ d, card_dim, x, y }) {
  return ({
    template: (`
   
  `)
  })
}

export function HideIcon({ d, card_dim }) {
  return ({
    template: (`
    <g transform="translate(${card_dim.w - 50},${card_dim.h - 20})scale(.035)" style="cursor: pointer" class="card_hide_rels hide_rels_icon">
      <circle fill="rgba(0,0,0,0)" r="256" cx="256" cy="256" />
      <g fill="currentColor">
        <path d="m34,256l26.2,26.2c108,108 283.7,108 391.7,0l26.1-26.2-26.2-26.2c-108-108-283.7-108-391.7,0l-26.1,
          26.2zm222,126.2c-75.8,0-151.6-28.9-209.3-86.6l-32.9-32.9c-3.7-3.7-3.7-9.7 0-13.5l32.9-32.9c115.4-115.4 303.2-115.4 418.6,
          0l32.9,32.9c3.7,3.7 3.7,9.7 0,13.5l-32.9,32.9c-57.7,57.7-133.5,86.6-209.3,86.6z"/>
        <path d="m256,183.5c-40,0-72.5,32.5-72.5,72.5s32.5,72.5 72.5,72.5c40,0 72.5-32.5 72.5-72.5s-32.5-72.5-72.5-72.5zm0,
          164c-50.5,0-91.5-41.1-91.5-91.5 0-50.5 41.1-91.5 91.5-91.5s91.5,41.1 91.5,91.5c0,50.5-41,91.5-91.5,91.5z"/>
      </g>
    </g>
  `)
  })
}

export function MiniTree({ d, card_dim }) {
  return ({

    template: (`
  
    <g class="card_family_tree" style="cursor: pointer" transform="scale(1.50) translate(16, 0)">
    <rect x="-31" y="-25" width="72" height="15" fill="rgba(0,0,0,0)"></rect>
    <g transform="translate(${card_dim.w * .8 - 75}, 6) scale(0.9)">
        <rect x="-31" y="-25" width="72" height="15" fill="rgba(0,0,0,0)"></rect>
        <line y2="-17.5" stroke="#282828" />
        <line x1="-20" x2="20" y1="-17.5" y2="-17.5" stroke="#282828" />
        
        <path d="M-10,-10 L-20,-17.5 L-10,-25 Z" fill="rgb(127, 170, 225)" />
        <path d="M-20,-25 L-30,-17.5 L-20,-10 Z" fill="rgb(127, 170, 225)" />
        <path d="M13,-10 L23,-17.5 L13,-25 Z" fill="rgb(184, 115, 178)" />
        <path d="M23,-25 L33,-17.5 L23,-10 Z" fill="rgb(184, 115, 178)" />
    </g>
</g>

  `)
  })
}

export function PlusIcon({ d, card_dim, x, y,color  }) {
  const gender_circle = d.data.data.gender === 'M' ? 'circle-male' : d.data.data.gender === 'F' ? 'circle-female' : 'card-genderless'

  return ({
    template: (`
    <g class="card_add_relative">
      <g transform="translate(${x ?? card_dim.w / 2},${y ?? card_dim.h})scale(.13)">
        <circle  class ="${gender_circle}" r="140" cx="10" cy="-110" style="fill: ${color};"  />
        <g transform="translate(-30, -180)">
        <line
        x1="-15" x2="125" y1="70" y2="70"
        stroke="currentColor" stroke-width="20" stroke-linecap="round"
    />
    <line
        x1="55" x2="55" y1="0" y2="140"
        stroke="currentColor" stroke-width="20" stroke-linecap="round"
    />
    
    
        </g>
      </g>
    </g>
  `)
  })
}


export function CrossIcon({ card_dim, size = 10, color = 'red' }) {
  return ({
    template: (`
    <g class="crossIcon card_remove_icon" transform="translate(${card_dim.w / 2 - size+70}, ${-card_dim.h / 2 + size + 30})">
      <line x1="0" y1="0" x2="${size}" y2="${size}" stroke="${color}" stroke-width="4"/>
      <line x1="0" y1="${size}" x2="${size}" y2="0" stroke="${color}" stroke-width="4"/>
    </g>
    `)
  });
}


export function PathIcon({ d, card_dim, x, y }) {

  return ({
    template: (`
<g class="card_add_path">
  <g transform="translate(${x || card_dim.w / 2}, ${y || card_dim.h}) scale(0.25)"> <!-- Increased scale for larger size -->
    <path
      d="M10 50 Q 50 -100, 90 50"
      style="stroke: #FF5733; stroke-width: 30; fill: #FF5733; stroke-linecap: round;" 
    />
  </g>
</g>

  `)
  })
}

export function LinkBreakIcon({ x, y, rt, closed }) {
  return ({
    template: (`
    <g style="
          transform: translate(-12.2px, -.5px);
          cursor: pointer;
        " 
        fill="currentColor" class="card_break_link${closed ? ' closed' : ''}"
      >
      <g style="transform: translate(${x}px,${y}px)scale(.02)rotate(${rt + 'deg'})">
        <rect width="1000" height="700" y="150" style="opacity: 0" />
        <g class="link_upper">
          <g>
            <path d="M616.3,426.4c19,4.5,38.1-7.4,42.6-26.4c4.4-19-7.4-38-26.5-42.5L522.5,332c-18,11.1-53.9,33.4-53.9,33.4l80.4,18.6c-7.8,4.9-19.5,12.1-31.3,19.4L616.3,426.4L616.3,426.4z"/>
            <path d="M727.4,244.2c-50.2-11.6-100.3,3.3-135.7,35.4c28.6,22.6,64.5,30.2,116.4,51.3l141,32.6c23.9,5.6,56.6,47.2,51.1,71l-4.1,17c-5.6,23.7-47.3,56.4-71.2,51l-143.4-33.2c-66.8-8.6-104.1-16.6-132.9-7.5c17.4,44.9,55.9,80.8,106.5,92.4L800.9,588c81.3,18.8,162.3-31.5,181.2-112.4l4-17c18.8-81.1-31.7-161.8-112.9-180.6L727.4,244.2z"/>
          </g>
        </g>
        <g class="link_lower">
          <path d="M421.2,384.9l-128,127.6c-13.9,13.8-13.9,36.2,0,50s36.3,13.8,50.2,0.1l136.2-135.8v-36.7l-58.4,58.1V384.9L421.2,384.9z"/>
          <path d="M204.6,742.8c-17.4,17.3-63.3,17.2-80.6,0.1l-12.3-12.3c-17.3-17.3,0.6-81.2,17.9-98.5l100.2-99.9c12.5-14.9,45.8-40.8,66.1-103.7c-47.7-9.4-98.9,4.2-135.8,40.9L54.2,575c-58.9,58.8-58.9,154,0,212.8L66.6,800c58.9,58.8,154.5,58.8,213.4,0l105.8-105.6c38.4-38.3,51.3-91.9,39.7-141c-44,22.7-89,62.3-116,84.8L204.6,742.8z"/>
        </g>
        <g class="link_particles">
          <path d="M351.9,248.4l-26.5,63.4l80.6,30.1L351.9,248.4z"/>
          <path d="M529.3,208l-43,26.6l35.4,52.3L529.3,208z"/>
          <path d="M426.6,158.8l-44-2.9l61.7,134.6L426.6,158.8z"/>
        </g>
      </g>
    </g>
  `)
  })
}

export function LinkBreakIconWrapper({ d, card_dim }) {
  let g = "",
    r = d.data.rels, _r = d.data._rels || {},
    closed = d.data.hide_rels,
    areParents = r => r.father || r.mother,
    areChildren = r => r.children && r.children.length > 0
  if ((d.is_ancestry || d.data.main) && (areParents(r) || areParents(_r))) { g += LinkBreakIcon({ x: card_dim.w / 2, y: 0, rt: -45, closed }).template }
  if (!d.is_ancestry && d.added) {
    const sp = d.spouse, sp_r = sp.data.rels, _sp_r = sp.data._rels || {};
    if ((areChildren(r) || areChildren(_r)) && (areChildren(sp_r) || areChildren(_sp_r))) {
      g += LinkBreakIcon({ x: d.sx - d.x + card_dim.w / 2 + 24.4, y: (d.x !== d.sx ? card_dim.h / 2 : card_dim.h) + 1, rt: 135, closed }).template
    }
  }
  return g
}

export function CardImage({ d, image, card_dim, maleIcon, femaleIcon,is_living,adopted,divorced,is_admin }) {
  return ({
    template: (`
  <g style="transform: translate(${card_dim.img_x}px,${card_dim.img_y}px);" clip-path="url(#card_image_clip_curved1)">
    ${image
      ? is_living 
        ? `<image href="`+image+`" class="card_image" height="${card_dim.img_h}" width="${card_dim.img_w}" preserveAspectRatio="xMidYMin slice" />`
        : ` <defs>
              <clipPath id="circleClip">
                  <circle cx="${card_dim.img_w / 2}" cy="${card_dim.img_h / 2}" r="${Math.min(card_dim.img_w, card_dim.img_h) / 2 - 1}" />
              </clipPath>
          </defs>
          <image href="${image}" class="card_image" height="${card_dim.img_h}" width="${card_dim.img_w}" preserveAspectRatio="xMidYMin slice" clip-path="url(#circleClip)" />
          <rect x="${-card_dim.img_w * 0.1}" y="${card_dim.img_h * 0.65}" width="${card_dim.img_w * 1.2}" height="10" fill="#808080" transform="rotate(-45 ${card_dim.img_w / 2} ${card_dim.img_h / 2})"/>
          <circle cx="${card_dim.img_w / 2}" cy="${card_dim.img_h / 2}" r="${Math.min(card_dim.img_w, card_dim.img_h) / 2}" fill="none" stroke="white" stroke-width="8"/>`
      : (d.data.data.gender === "F" && !!femaleIcon) ? femaleIcon({ card_dim })
        : (d.data.data.gender === "M" && !!maleIcon) ? maleIcon({ card_dim })
          : GenderlessIcon(is_living)
    }
     ${is_admin?
     `<image 
        href="${gear_icon}" 
        x="4" 
        y="38" 
        width="16" 
        height="16" 
        class="gear-icon"
      />`:''}
    ${adopted ? `
      <image 
        href="${leaf}" 
        x="${card_dim.img_w - 28}" 
        y="${card_dim.img_h - 18}" 
        width="16" 
        height="16"
        class="adopted-leaf"
      />` : ''}
       ${divorced ? `
      <image 
        href="${broken_heart}" 
        x="${card_dim.img_w - 28}" 
        y="${card_dim.img_h - 18}" 
        width="16" 
        height="16"
        class="broken-heart"
      />` : ''}
</g>

  
  `)
  })

  function GenderlessIcon(is_living) {
    return (`
      ${is_living
        ? `<g class="genderless-icon">
              <!-- Background rectangle -->
              <rect height="${card_dim.img_h}" width="${card_dim.img_w}" rx="30" ry="30" fill="rgb(59, 85, 96)" />
      
              <!-- Scaled inner icon -->
              <g transform="scale(${card_dim.img_w * 0.001616})">
                <path transform="translate(50,40)" fill="lightgrey" d="M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 
                  64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 
                  0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"/>
              </g>
            </g>`
        : `<g class="genderless-icon">
              <!-- Outer circle with stroke -->
              <circle cx="${card_dim.img_w / 2}" cy="${card_dim.img_h / 2}" r="${Math.min(card_dim.img_w, card_dim.img_h) / 2 + 1}" fill="none" stroke="white" stroke-width="8"/>
      
              <!-- Main group with image and overlays -->
              <g>
                <!-- Background rectangle -->
                <rect height="${card_dim.img_h}" width="${card_dim.img_w}" rx="30" ry="30" fill="rgb(59, 85, 96)" />
      
                <!-- Inner path -->
                <g transform="scale(${card_dim.img_w * 0.001616})">
                    <path transform="translate(50,40)" fill="lightgrey" d="M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 
                        64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 
                        0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"/>
                </g>
      
                <!-- Diagonal band -->
                <rect x="${-card_dim.img_w * 0.1}" y="${card_dim.img_h * 0.65}" width="${card_dim.img_w * 1.2}" height="10" fill="#808080" transform="rotate(-45 ${card_dim.img_w / 2} ${card_dim.img_h / 2})"/>
      
                <!-- Inner circle -->
                <circle cx="${card_dim.img_w / 2}" cy="${card_dim.img_h / 2}" r="${Math.min(card_dim.img_w, card_dim.img_h) / 2}" fill="none" stroke="white" stroke-width="8"/>
              </g>
            </g>`
      }
      
  
    `)
  }
}




const FileToBase64Converter = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [base64String, setBase64String] = useState('');

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64String(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return base64String;
};

export default FileToBase64Converter;
